module.exports = __webpack_public_path__ + "assets/b57a119dc3c8cfbef1d625b218883216.mp3";